/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Heading, Text } from "@chakra-ui/react";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSetRecoilState } from "recoil";
import FullscreenLoader from "../components/fullscreenLoader";
import LanguageSwitcher from "../components/languageSwitcher";
import Results from "../components/results";
import Settings from "../components/settings";
import i18n from "../language/i18n";
import {
  configurationState,
  infoModalAtom,
  printLocalAtom,
} from "../state/state";
import { downloadConfig } from "../utils/config";
// @ts-ignore
import infoModalDe from "../assets/info/infoModal_de.md";
// @ts-ignore
import infoModalEn from "../assets/info/infoModal_en.md";
// @ts-ignore
import infoModalFr from "../assets/info/infoModal_fr.md";

const Root = () => {
  const { t } = useTranslation();
  const [loadingConfig, setLoadingConfig] = useState(true);

  const setConfig = useSetRecoilState(configurationState);
  const setInfoModal = useSetRecoilState(infoModalAtom);
  const setPrintLocal = useSetRecoilState(printLocalAtom);

  /**
   * Workaround for firedos website scrolling down to our app, if app loads.
   * Fix: Scroll to top on app load.
   */
  useCallback(() => {
    window.scrollTo(0, 0);
  }, []);

  /**
   * Read config at app launch & on language switch.
   */
  useEffect(() => {
    downloadConfig()
      .then((result) => {
        setConfig(result.config);
        setInfoModal(result.infoModal);
      })
      .catch(() => {
        console.log(
          "Couldn't fetch or validate cloud config. Fallback to offline configuration."
        );
        // Switch to local print pdf verson.
        setPrintLocal(true);
        // Get local infomodal.
        switch (i18n.language) {
          case "en":
            fetch(infoModalEn)
              .then((res) => res.text())
              .then((modal) => setInfoModal(modal));
            break;
          case "fr":
            fetch(infoModalFr)
              .then((res) => res.text())
              .then((modal) => setInfoModal(modal));
            break;
          default:
            fetch(infoModalDe)
              .then((res) => res.text())
              .then((modal) => setInfoModal(modal));
            break;
        }
      })
      .finally(() => setLoadingConfig(false));
  }, [i18n.language]);

  return (
    <>
      {loadingConfig ? (
        <FullscreenLoader />
      ) : (
        <>
          <LanguageSwitcher />
          <Box padding="5">
            <Heading as="h1" size="sm" variant="redDot">
              {t("title")}
            </Heading>
            <Text fontSize="md">{t("text")}</Text>
          </Box>
          <Box padding="5" bg="brand.gray.50" borderRadius="2xl" boxShadow="lg">
            <Settings />
            <Results />
          </Box>
        </>
      )}
    </>
  );
};

export default Root;
